import React, { useState, useEffect } from 'react';

function TextModal({ position, existingText, onSave, onClose }) {
  const [text, setText] = useState(existingText?.text || '');
  const [fontSize, setFontSize] = useState(existingText?.fontSize || 16);
  const [fontWeight, setFontWeight] = useState(existingText?.fontWeight || 'normal');
  const [rotation, setRotation] = useState(existingText?.rotation || 0);

  const handleSave = () => {
    if (text.trim()) {
      onSave({
        text: text.trim(),
        x: position.x,
        y: position.y,
        fontSize,
        fontWeight,
        rotation,
        id: Date.now()
      });
    }
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      background: 'transparent', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', zIndex: 1000
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 8,
        boxShadow: '0 2px 12px rgba(25,118,210,0.12)',
        padding: 16,
        width: 300,
        margin: '16px 0 0 16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        position: 'relative',
      }}>
        <h3 style={{
          textAlign: 'center',
          fontSize: '1rem',
          fontWeight: 600,
          marginBottom: 12,
          letterSpacing: 0.01,
          color: '#02414a',
        }}>{existingText ? 'Edit Text' : 'Add Text'}</h3>
        
        <div style={{ marginBottom: 10 }}>
          <label style={{ fontWeight: 500, marginBottom: 2, display: 'block', fontSize: 12 }}>Text</label>
          <textarea
            value={text}
            onChange={e => setText(e.target.value)}
            placeholder="Enter your text here..."
            style={{ 
              width: '100%', 
              fontSize: 12, 
              padding: 8, 
              borderRadius: 3, 
              border: '1px solid #e0e0e0',
              minHeight: '60px',
              resize: 'vertical'
            }}
            autoFocus
          />
        </div>
        
        <div style={{ marginBottom: 10 }}>
          <label style={{ fontWeight: 500, marginBottom: 2, display: 'block', fontSize: 12 }}>Font Size</label>
          <input 
            type="range" 
            min={12} 
            max={48} 
            value={fontSize} 
            onChange={e => setFontSize(Number(e.target.value))} 
            style={{ width: '100%' }}
          />
          <span style={{ fontSize: 11, color: '#02414a', fontWeight: 500 }}>{fontSize}px</span>
        </div>
        
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontWeight: 500, marginBottom: 2, display: 'block', fontSize: 12 }}>Font Weight</label>
          <select 
            value={fontWeight} 
            onChange={e => setFontWeight(e.target.value)}
            style={{ width: '100%', fontSize: 12, padding: 4, borderRadius: 3, border: '1px solid #e0e0e0' }}
          >
            <option value="normal">Normal</option>
            <option value="bold">Bold</option>
          </select>
        </div>
        
        {/* <div style={{ marginBottom: 12 }}>
          <label style={{ fontWeight: 500, marginBottom: 2, display: 'block', fontSize: 12 }}>Rotation</label>
          <input 
            type="range" 
            min={0} 
            max={360} 
            value={rotation} 
            onChange={e => setRotation(Number(e.target.value))} 
            style={{ width: '100%' }}
          />
          <span style={{ fontSize: 11, color: '#02414a', fontWeight: 500 }}>{rotation}°</span>
        </div> */}
        
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 6, marginTop: 10 }}>
          <button 
            onClick={onClose} 
            style={{ padding: '4px 12px', background: '#f0f0f0', color: '#02414a', border: 'none', borderRadius: 3, fontWeight: 500, fontSize: 11 }}
          >
            Cancel
          </button>
          <button 
            onClick={handleSave} 
            style={{ padding: '4px 12px', background: '#02414a', color: '#fff', border: 'none', borderRadius: 3, fontWeight: 500, fontSize: 11 }}
          >
            {existingText ? 'Update Text' : 'Add Text'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default TextModal;
